
import { useEffect, useRef } from "react"

import { useDispatch, useSelector } from "react-redux"

import { BrowserRouter, Routes, Route } from "react-router"

import { RootState } from "../store"

import { login } from "../store/slices/AuthSlice"

import { PrivateRoute } from "./PrivateRoute"
import { PublicRoute } from "./PublicRoute"

import { KioscoRoutes } from "./KioscoRoutes"

import { LoginPage } from "../pages/auth/LoginPage"

import { ServiciosPage } from "../pages/comun/ServicioPage"
import { HomePage } from "../pages/comun/HomePage"

export const AppRouter = () => {

    const dispatch = useDispatch();

    const token = useRef<String | null>(null);

    const { token: tokenRedux } = useSelector( ( state: RootState ) => state.auth );

    const data = window.localStorage.getItem("data");

    useEffect(() => {
        
        if( data ){

            dispatch( login( JSON.parse( data ) ) );

        } 
        else{            
            localStorage.removeItem('data');
            localStorage.removeItem('lastPath');
        }      

    }, [ data, dispatch ]); 

    if( data ){
        const dataJSON = JSON.parse( data );

        if( dataJSON ){
            token.current = dataJSON.token;
        }
    }
    else{
        token.current = tokenRedux ?? '';
    }

    return (

        <BrowserRouter>  

            <Routes>

                <Route path="/login" element={ <PublicRoute token={ token.current } children={ <LoginPage /> } /> } />   

                <Route path="/" element={ <PublicRoute token={ token.current } children={ <HomePage /> } /> } />   

                <Route path="/servicios/:id" element={ <PublicRoute token={ token.current } children={ <ServiciosPage /> } /> } />  

                <Route path="/*" element={ <PrivateRoute token={ token.current } children={ <KioscoRoutes /> } /> } />      
            
            </Routes>
        
        </BrowserRouter>
    
    )
}